import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { IoIosCall } from "react-icons/io";
import { FaFirefoxBrowser } from "react-icons/fa";
import Swal from "sweetalert2";
import { publicKey, templateId, serviceId } from "../../utils/axios";
import { Helmet } from "react-helmet";

const Contact = () => {
  const form = useRef();
  // Send Emails
  const sendEmailMessage = (e) => {
    e.preventDefault();

    emailjs.sendForm(serviceId, templateId, form.current, publicKey).then(
      (result) => {
        // console.log(result.text);
        Swal.fire({
          icon: "success",
          text: "Message Sent Successfully",
        });
        form.current.reset();
      },
      (error) => {
        // console.log(error.text);
        Swal.fire({
          icon: "warning",
          text: `Error! Try Again`,
        });
      }
    );
  };

  // const [name, setName] = useState("");
  // const [email, setEmail] = useState("");
  // const [message, setMessage] = useState("");
  // const [subject, setSubject] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
  }, []);

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  // console.log(name);
  // console.log(email);
  // console.log(subject);
  // console.log(message);
  // };

  return (
    <section className="mx-auto max-w-[1380px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact Us | RIBI BLOOD</title>
        <link rel="canonical" href="https://ribiblood.com/contact-us" />
      </Helmet>
      {/* Top Hero */}
      <section className="shadow border-t-2 border-slate-200">
        {/* <div className={styles.imageContainer}> */}
        <div className="flex justify-center items-center text-center py-32 lg:px-4 px-8">
          {" "}
          <p className=" text-[#f6655f] text-4xl leading-normal font-bold">
            YOU CAN REACH US ANYTIME{" "}
          </p>
        </div>
      </section>

      <div className="contact font-poppins my-5 px-0 lg:px-10">
        <div className="flex flex-col justify-between lg:my-24 lg:flex-row-reverse">
          <div className="form lg:w-3/5 lg:shadow-lg lg:p-5 px-6 py-8">
            <h5 className="text-2xl font-semibold my-3 px-4">
              Send us a Message
            </h5>
            <form
              className="px-0 md:px-6 lg:px-6 py-5 flex flex-col gap-4"
              ref={form}
              onSubmit={sendEmailMessage}
            >
              <div>
                <label>Name*</label>
                <input
                  type="text"
                  name="user_name"
                  className="border-2 w-full col-span-2 py-3 rounded-lg px-3"
                  required
                />
              </div>
              <div>
                <label>Email*</label>
                <input
                  type="email"
                  name="user_email"
                  className="border-2 w-full col-span-2 py-3 rounded-lg px-3"
                  required
                />
              </div>
              <div>
                <label>Subject*</label>
                <input
                  type="text"
                  name="user_subject"
                  className="border-2 w-full col-span-2 py-3 rounded-lg px-3"
                  required
                />
              </div>
              <div>
                <label>Message*</label>
                <textarea
                  name="message"
                  className="border-2 w-full col-span-2 py-3 rounded-lg px-3 resize-none h-32"
                  required
                />
              </div>
              <input
                type="submit"
                value="Send"
                className="border-2 w-full col-span-2 py-3 rounded-full px-3 text-white bg-[#f6655f] cursor-pointer hover:bg-red-600 outline-none border-none"
              />
            </form>
          </div>

          <div className="lg:w-3/5 border-t-2 lg:border-0 border-opacity-75 px-6 py-8">
            <h5 className="font-semibold">
              We look forward to hearing from you.
            </h5>
            <p className="my-4">
              Send us a message using the form on this page, or connect with us
              via the contact info below.
            </p>
            <div className="border-t-2 border-b-2 border-opacity-75 mr-5">
              <ul className="my-5">
                <li className="flex items-center">
                  <IoIosCall className="text-red-400" />
                  <p className="ml-2 text-sm">+234 1234567890</p>
                </li>
                <li className="flex my-4 items-center">
                  {/* <img src={mail} alt="" /> */}
                  <MdEmail className="text-red-400" />
                  <p className="ml-2 text-sm">ribiblood@gmail.com</p>
                </li>
                <li className="flex my-4 items-center">
                  <FaFirefoxBrowser className="text-red-400" />

                  <p className="ml-2 text-sm">www.ribiblood.com</p>
                </li>
                <li className="flex items-center">
                  <MdLocationOn className="text-red-400" />

                  <p className="ml-2 text-sm">Lagos, Nigeria</p>
                </li>
              </ul>
            </div>
            <div className="socials">
              <h5 className="font-semibold my-2">Connect with us</h5>
              <div className="flex flex-row space-x-4">
                <Link
                  to="/"
                  className="bg-[#f6655f] flex justify-center items-center rounded-full p-2"
                >
                  <FaFacebookF size={22} color="white" />
                </Link>
                <Link
                  to="/"
                  className="bg-[#f6655f] flex justify-center items-center rounded-full p-2"
                >
                  <FaTwitter size={22} color="white" />
                </Link>
                <Link
                  to="/"
                  className="bg-[#f6655f] flex justify-center items-center rounded-full p-2"
                >
                  <FaLinkedinIn size={22} color="white" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
